module.exports = __webpack_public_path__ + "static/dev-58824ea08e1b2476ba20dc63ac74a5e2.png";